import { ChangeTabEvent, LocationFilterEvent } from '../opac.directive';
import { Component, Inject, Input, Output, EventEmitter } from 'ng-metadata/core';


import { LocationsService } from './locations.service';
//your imports go here
import { OpacService } from '../opac.service';
import { OPAC_TAB } from '../opac.directive';
import { LocationsFilterService } from '../locationsFilter/locationsFilter.service';
import { LocationService } from './location/location.service';
import { ConfigurationUtil } from '../../../../../nddUtils/configurationUtil.service';

const cloneDeep = require('lodash/cloneDeep');
import { getBackendSystem, getInstitutionCode, isHoldingsDisplayInLocationsList} from '../../../../../appConfig/appConfigForward';
import { UserSessionManagerService } from '../../../../../security/userSessionManager.service';
import { SmoothScrollUtil } from '../../../../../nddUtils/smoothScrollUtil.service';

const get = require('lodash/get');
const isEqual = require('lodash/isEqual');

@Component({
    selector: 'prm-locations',
    templateUrl: 'components/search/fullView/getit/opac/locations/locations.html',
})
export class PrmLocations {
    @Input() private item: Object;
    @Input() public memberInst: string;
    @Input() public isFiltered: boolean;
    @Input() public filters: Object;
    @Input() public registerUser: string;
    @Input() public locToUpdate: string;
    @Input() public serviceScrollId:string;
	@Output() private changeTabEvent: EventEmitter<ChangeTabEvent> = new EventEmitter();
	private locs: Object;

    @Input() public headerLabel:string;
    @Output() private locationFilterEvent: EventEmitter<LocationFilterEvent> = new EventEmitter();
    @Output() private libraryFilterEvent: EventEmitter <Object> = new EventEmitter();
    @Input() public enableLibraryLevelList:boolean = false;
    @Input() public isOverlayFullView:boolean;

    public dropDownOptions: Object;
    private _results: Array<Array<Location>>;
    private unfilteredResults: Array<Array<Location>>;
    private _displayFiltersButton: boolean = false;
    private hideShowmore: boolean = false;
    @Input() public isLocationsFilterVisible: boolean;
    private locationsPrefilter: Array<string>;
    private locationsPrefilterActive: boolean = false;
    private relatedLocationsListLimit = 10;

    private manualRegistrationInProgress : boolean  = false;
    private manualRegistrationFailed : boolean = false;

    constructor(private configurationUtil: ConfigurationUtil,
        		private locationsService: LocationsService,
        		private opacService: OpacService,
        		@Inject('opacLocations') private opacLocations,
        		@Inject('$scope') private $scope: ng.IScope,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                private smoothScrollUtil: SmoothScrollUtil,
        		private locationsFilterService: LocationsFilterService,
        		private locationService: LocationService,
        		private userSessionManagerService: UserSessionManagerService,
                @Inject('$rootScope') private $rootScope: ng.IRootScopeService) {
        let isOtherInst = false;
        if (this.memberInst) {
            console.log("memberInst " + this.memberInst);
            isOtherInst = getInstitutionCode() ? !(getInstitutionCode() === this.memberInst) : false;
        }
        if (!this.filters) {
            this.filters = {};
        }
        this.locationsPrefilter = this.locationsService.getLocationsPrefilterConf();
        this.locationsPrefilterActive = this.locationsPrefilter.length > 0 && !isOtherInst;
        this._displayFiltersButton = this.configurationUtil.getLocationsConfiguration()['displayholdingsfilters'];
    }

    ngOnInit() {
        //setup
        this.locationsFilterService.deleteFilterOptions();
        this.activate();
        this.$scope.$watch(() => this.isFiltered, (newVal, oldVal) => {
            if (!newVal && oldVal) {
                this.clearFilters(this.isLocationsFilterVisible);
            }
        });
        this.$scope.$watch(() => this.item.delivery.holding, (newVal, oldVal) => {
            this.results = this.locationsService.getLocations(this.item);
            if(this.isShouldDisplayHoldingsInLocationsList()) {
                this.locationsService.getLocationsItems(this.results, false, false, {}, get(this.item, 'delivery.hideResourceSharing', false), get(this.item, 'delivery.almaInstitutionsList[0].envURL', ''));
            }
        });
        this.$scope.$watch(() => this.memberInst, (newVal, oldVal) => {
            if (!isEqual(newVal, oldVal)) {
                this.activate();
            }
        });
        this.$scope.$on('locationFilterEvent',(event,location) => {
            this.handleFilter({location: location });
        });
        this.$scope.$on('libraryFilterEvent',(event,$event) => {
            this.handleFilter($event);
        });
        this.$scope.$on('clearFiltersEvent',(event) => {
            this.clearFilters(false);
        });
    }

    get results() {
        return this._results;
    }

    set results(results) {
        if (this.locationsPrefilterActive && this.locationsPrefilter && this.locationsPrefilter.length > 0) {
            this._results = this.locationsService.preFilterLocations(this.locationsPrefilter, results);
            if ((get(results, '[0]', []).length === get(this._results, '[0]', []).length) && (get(results, '[1]', []).length === get(this._results, '[1]', []).length)) {
                this.locationsPrefilterActive = false;
            }
        }
        else {
            this._results = results;
        }
    }

    get displayFiltersButton() {
        return this._displayFiltersButton;
    }

    private activate() {
        let results = this.locationsService.getLocations(this.item);
        this.unfilteredResults = cloneDeep(results);
        this.results = results;
        if (!this.isSuprima()) {
            this.checkAndSwitchToItemsTabAutomatically(0);
        } else if (this.isSuprima() && this.isSingleOvpLocation(this.item)) {
            this.switchToItemsTab(false, undefined, true);
        }

    }

    private checkAndSwitchToItemsTabAutomatically(attempt) {
        if (attempt > 10) {
            return;
        }

        /* We want to check the this.locationsService.isSingleOvpLocation() API only once */
        if (attempt === 0 && !this.isSingleOvpLocation(this.item)) {
            return;
        }

        if (!this.item.rtaInProgress) {
            this.switchToItemsTab(false, {}, true);
        } else {
            attempt++;
            setTimeout(() => { this.checkAndSwitchToItemsTabAutomatically(attempt) }, 100);
        }
    }

    private isSingleOvpLocation(items) {
        let locations = this.results.reduce((prev, cur) => prev.concat(cur));
        return (locations.length == 1 && this.locationService.isOvpLocation(locations[0]));
    }

    private switchToItemsTab(filtersCall, filters, cancelFocus?) {
        let loc;
        const locations = this.locations || [];
        const otherLocations = this.otherLocations || [];
        let thereAreLocs = locations.length > 0 || otherLocations.length > 0;
        if (thereAreLocs) {
            loc = locations[0] ? locations[0] : otherLocations[0];
            this.gotoLocationItemsTab(loc, false, filtersCall, filters, cancelFocus);
        }
    }

    public gotoLocationItemsTab(loc, fromShowMore, filtersCall, filters, cancelFocus?) {
        filters = filters || this.filters || {};
        if (this.isSuprima()) {
            filters.location = loc.location.libraryCode;
        }
        let isFilter = filtersCall ? filtersCall : false;
        let eventData = {
            referer: OPAC_TAB.LOCATIONS,
            dest: OPAC_TAB.ITEMS,
            loc: loc,
            isFiltered: isFilter,
            filters: filters,
            locationsFilterVisible: this.isLocationsFilterVisible,
            dropDownOptions: this.dropDownOptions,
            cancelFocus: cancelFocus
        }
        if (!loc.items || loc.items.length === 0) {
            window.appPerformance.serverTimeLog = window.appPerformance.serverTimeLog ? window.appPerformance.serverTimeLog : [];
            window.appPerformance.serverTimeLog['getLocItems'] = -1;
            let promise = this.locationsService.getItems(loc, fromShowMore, isFilter, filters, get(this.item, 'delivery.hideResourceSharing', false), get(this.item, 'delivery.almaInstitutionsList[0].envURL', ''));
            if (promise) {
                promise.then((res) => {
                    this.dropDownOptions = this.locationsService.updateFilterDropDownOptions(get(res, 'data.possibleFilters'), get(res, 'data.itemInfo.locations'));
                    eventData.dropDownOptions = this.dropDownOptions;
                    eventData.restoreServices = false;
                    this.changeTabEvent.emit(eventData);
                    //just one holding - calling the items call in first full view load
                    if (get(res.data,'itemInfo.locations.length') === 1) {
                        window.appPerformance.serverTimeLog['getLocItems'] = res.data.beaconO22;
                    }
                });
            }
            this.changeTabEvent.emit(eventData);
        } else {
            this.changeTabEvent.emit(eventData);
        }
    }

    get Library(){
        return this.locationsFilterService.getLocationDropDownOptions(this.item);  
    }

    private getLocationCode(location){
				        return location.split(":",2)[0];
    }
    public sendLocationFilter(location){
        let eventData = {locationFilter: this.getLocationCode(location)};
        this.locationFilterEvent.emit(eventData);
    }

    public  sendLibraryFilterEvent($event) {
        this.libraryFilterEvent.emit($event);   
    }

    get locations() {
        if (!this.results) {
            return;
        }
        if (this.locToUpdate && this.isSuprima()) {
            this.results = this.locationsService.getLocations(this.item);
            this.locToUpdate = undefined;
        }
        return this.results[0].filter((loc) => !loc.location.relatedTitle);
    }

    get locationsForDisplay(){
        if(this.locations.length > 10 && !this.hideShowmore){
            return this.locations.slice(0,10);
        }
        return this.locations;
    }

    get otherLocations() {
        if (!this.results) {
            return;
        }
        if (this.locToUpdate && this.isSuprima()) {
            this.results = this.locationsService.getLocations(this.item);
            this.locToUpdate = undefined;
        }
        return this.results[1];
    }

    get relatedLocations() {
        if (!this.results) {
            return;
        }
        if (this.locToUpdate && this.isSuprima()) {
            this.results = this.locationsService.getLocations(this.item);
            this.locToUpdate = undefined;
        }
        return this.results[0].filter((loc) => loc.location.relatedTitle != null && loc.location.relatedTitle !== '');
    }

    get hasRelatedLocations() {
        let hasRelated = false;
        if (!this.results) {
            return hasRelated;
        }
        let locations = this.results.reduce((prev, cur) => prev.concat(cur));
        locations.forEach((f, index) => {
            if (f.location.relatedTitle != null && f.location.relatedTitle !== '') {
                hasRelated = true;
            }
        });
        return hasRelated;
    }

    get hasRelatedTitle(loc) {
        return loc.relatedTitle != null && loc.relatedTitle !== '';
    }

    public filterClick() {
        this.isLocationsFilterVisible = !this.isLocationsFilterVisible;
        if (!this.isLocationsFilterVisible) {
            this.clearFilters(false);

        }
    }

    clearFilters(locationsFilterVisible) {
        this.locationsService.clearFilters(this.item, false);
        this.dropDownOptions = undefined;
        this.results = cloneDeep(this.unfilteredResults);
        if(this.isShouldDisplayHoldingsInLocationsList) {
            this.locationsService.getLocationsItems(this.results, false, false, {}, get(this.item, 'delivery.hideResourceSharing', false), get(this.item, 'delivery.almaInstitutionsList[0].envURL', ''));
        }
        this.isLocationsFilterVisible = locationsFilterVisible;
        this.filters = {};
    }

    public handleFilterEvent($event) {
        if (this.enableLibraryLevelList){
            this.sendLibraryFilterEvent($event);
        }else {
            this.handleFilter($event);
        }
    }

    public handleFilter($event) {
        
        let promise = this.locationsService.performFilter($event, this.unfilteredResults, get(this.item, 'delivery.hideResourceSharing', false), get(this.item, 'delivery.almaInstitutionsList[0].envURL', ''));
        if (!promise) {
            return;
        }

        promise.then((res) => {
            this.results = get(res, 'data.itemInfo.results') || get(res, 'results');
            let otherInstLocs = this.results[1];
            this.dropDownOptions = this.locationsService.updateFilterDropDownOptions(get(res, 'data.possibleFilters'), get(res, 'data.itemInfo.locations'));
            let numOfLocations = this.results[0].length + (otherInstLocs != undefined ? otherInstLocs.length : 0);
            if (numOfLocations === 1) { // Only 1 location - go to location items tab
                setTimeout(()=>{
                    this.switchToItemsTab(true, { location: $event.location, volume: $event.volume, year: $event.year, description: $event.description });  
                }, 400);
            } else if(this.enableLibraryLevelList && numOfLocations > 1) { // Only for VE (when we enabled three levels) : More than 1 location --> it means, we stay on locations tab : middle level (not location items tab).
                this.sctrollToTabsArea();
            }
            this.$scope.$apply();
        });
    }

    public sctrollToTabsArea(){
        this.$timeout(() => {
            let scrollerContainerTagName = this.isOverlayFullView ? 'sticky-scroll' : '';
            this.smoothScrollUtil.scrollTo(this.serviceScrollId, '', scrollerContainerTagName);
        }, 100)
    }

    private isLoggedIn() {
        return (this.userSessionManagerService.getUserName() &&
            this.userSessionManagerService.getUserName().length > 0);
    }

    showRegisterUser() {
        if (this.isLoggedIn() && getBackendSystem() === 'suprima' && this.registerUser === 'Manual') {
            return true;
        }
        return false;
    }

    private reloadWithRegisterUser(){
        this.registerUser = '';
        this.manualRegistrationInProgress = true;
        this.locationsService.registerManualLinkedUser(this.memberInst, get(this.item, 'delivery.almaInstitutionsList[0].envURL', ''))
            .then((res) => {
                if(res.userId){
                    // Reload the page to allow user registration to take effect
                    this.manualRegistrationFailed = false;
                    location.reload();
                } else {
                    this.manualRegistrationFailed = true;
                }
            }).catch((error) => {
                this.manualRegistrationFailed = true;
            }).finally(() => {
                this.manualRegistrationInProgress = false;
            });  
    }

    private isSuprima() {
        return (this.configurationUtil.getBackendSystem() === 'suprima');
    }

    public disableLocationsPrefilter() {
        this.locationsPrefilterActive = false;
        this._results = this.unfilteredResults;
        if(this.isSuprima()){
            let recordId = this.item.pnx.control.recordid;
            this.$rootScope.$broadcast('unfilterLocationsPressedEvent', recordId);
        }
    }

    public showMore() {
        this.hideShowmore = true;
    }

    public showMoreRelatedLocations() {
        this.relatedLocationsListLimit += 10;
    }

    public isShouldDisplayHoldingsInLocationsList() : boolean {
        if(this.isSuprima() && isHoldingsDisplayInLocationsList()){
            if(get(this.locations, "length",0)>10){
                return false;
            }
            if(get(this.relatedLocations, "length",0)>10){
                return false;
            }
            if(get(this.otherLocations, "length",0)>10){
                return false;
            }
            return true;
        }
        return false;
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/locations/locations.directive.ts